// extracted by mini-css-extract-plugin
export default {"dataGridWrapper":"Datatable_dataGridWrapper__Rq0qb","searchBar":"Datatable_searchBar__Y9dwk"};